// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { EmployeeTimeManagementAreaId } from './EmployeeTimeManagementAreaId'
import { EmployeeTimeManagementAreaNavigation } from './EmployeeTimeManagementAreaNavigation'
import { EmployeeTimeManagementAreaRoutes } from './EmployeeTimeManagementAreaRoutes'

const LazyEmployeeTimeManagementComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./EmployeeTimeManagementArea')),
)

const EmployeeTimeManagementComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyEmployeeTimeManagementComponent />
  </SuspenseLoadingWrapper>
)

export const EmployeeTimeManagementArea = {
  id: EmployeeTimeManagementAreaId,
  requiredRight: BoumRight.AREA_TIME_MANAGEMENT_ALERTS,
  NavigationComponent: EmployeeTimeManagementAreaNavigation,
  route: {
    path: EmployeeTimeManagementAreaRoutes.route,
    component: EmployeeTimeManagementComponent,
  },
}
